module.exports = __webpack_public_path__ + "img/facial_hair_full_beard_thick_extra_rect_mask.6a2865d4.png";